import { yupResolver } from "@hookform/resolvers/yup";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import SelectComponent from "../../../components/inputs/Select/SelectComponent";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";
import { routes } from "../../../routes";
import { createLateFeeConfig, updateLateFeeConfig } from "../../../services/finance/lateFeeConfig";
import { LateFeeConfigType } from "../../../types/Finance";
import { CreateLateFeeConfigFormValidation } from "./CreateLateFeeConfigFormValidation";
import { useGetPaymentTypesQuery } from "../../../hooks/useGetPaymentTypesQuery";
import { updatePaymentType } from "../../../services/finance/paymentType";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useAppDispatch } from "../../../hooks/hooks";
import { resetLateFeeConfigData } from "../../../redux/slices/finance/lateFeeConfig";

export const UpdateLateFeeConfig = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const mutation = useMutation({ mutationFn: updateLateFeeConfig, mutationKey: 'updateLateFeeConfig' });
  const { data: paymentTypesData } = useGetPaymentTypesQuery({ PageNumber: 1, PageSize: 4000 });
  const lateFeeConfigFormData = useSelector((state: RootState) => state.lateFeeConfig);

  const defaultValues: LateFeeConfigType = lateFeeConfigFormData;
  const { control, handleSubmit, formState: { errors }, setValue, watch } = useForm<LateFeeConfigType>
    (
      {
        resolver: yupResolver(CreateLateFeeConfigFormValidation),
        defaultValues,
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        shouldUseNativeValidation: false,
      }
    );
  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Regra actualizada com sucesso!");
        handleBack();
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
  const handleBack = () => {
    navigate(routes.lateFeeConfigs);
    dispatch(resetLateFeeConfigData());
  }
  const watchFeePercentage = watch('feePercentage');
  const watchIdPayment = watch('idPaymentType');
  const handleSelectPaymentType = (id: string) => {
    const paymentType = paymentTypesData?.items.find(i => i.id === id);
    const amount = paymentType?.amount ?? 0;
    const feeAmount =   (amount * (watchFeePercentage / 100));
    setValue('feeAmount', feeAmount)
  }
  const handleFeePercentageChange = (e: any) => {
    const feePercentage = e?.target?.value;
    setValue('feePercentage', Number(feePercentage))
    const paymentType = paymentTypesData?.items.find(i => i.id === watchIdPayment);
    const amount = paymentType?.amount ?? 0;
    const feeAmount =  (amount * (feePercentage / 100));
    setValue('feeAmount', feeAmount)
  }
  return (
    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>
          <SelectComponent name="idPaymentType" label="Tipo de emolumento" control={control} errors={errors} style={{ width: '100%' }}
            options={paymentTypesData?.items.map((paymentType) => ({
              value: paymentType?.id ?? "",
              label: paymentType?.description ?? ""
            }))}
            onSelect={handleSelectPaymentType}
            required={true}
          />
          <Flex direction='row' gap='4'>
            <TextFieldComponent name="feePercentage" label="Percentagem de atraso (%)" control={control} errors={errors} fieldProps={{ placeholder: 'Percentagem de atraso', onChange: handleFeePercentageChange }} style={{ width: '100%' }} />
            <TextFieldComponent name="startDay" label="Dia inicial" control={control} errors={errors} fieldProps={{ placeholder: 'Dia inicial' }} style={{ width: '100%' }} />
            <TextFieldComponent name="endDay" label="Dia limite" control={control} errors={errors} fieldProps={{ placeholder: 'Dia limite' }} style={{ width: '100%' }} />
            {/* <TextFieldComponent name="daysAfterDueDate" label="Número de dias" control={control} errors={errors} fieldProps={{ placeholder: 'Número de dias' }} style={{ width: '100%' }} /> */}
          <TextFieldComponent name="feeAmount" label="Valor de atraso" control={control} errors={errors} fieldProps={{ placeholder: 'Valor de atraso', disabled: 'disabled' }} style={{ width: '100%' }} />
          </Flex>
          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> Voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading}>
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Actualizar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
}
